import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { endOfMonth, startOfMonth } from "date-fns";

/** Inclusive month-index bounds used to paint the month grid range. */

/** Orders two months and snaps them to a full 'start of first → end of last' range. */
export function snapMonthRange(a, b) {
  var start = a;
  var end = b;
  if (end < start) {
    var _ref = [end, start];
    start = _ref[0];
    end = _ref[1];
  }
  return [startOfMonth(start), endOfMonth(end)];
}

/**
 * Resolves the month bounds to highlight: the pending selection previewed to
 * the hovered month, else the committed value, else none.
 */
export function resolveMonthBounds(pendingStart, hoveredMonth, committed) {
  if (pendingStart) {
    var a = startOfMonth(pendingStart);
    var b = startOfMonth(hoveredMonth || pendingStart);
    return a <= b ? {
      start: a,
      end: b
    } : {
      start: b,
      end: a
    };
  }
  var _committed = _slicedToArray(committed, 2),
    start = _committed[0],
    end = _committed[1];
  if (start && end) {
    return {
      start: startOfMonth(start),
      end: startOfMonth(end)
    };
  }
  return null;
}

/** Reports whether a month cell is within, and/or an edge of, the given bounds. */
export function getMonthCellState(year, monthIndex, bounds) {
  if (!bounds) return {
    inRange: false,
    edge: false
  };
  var time = startOfMonth(new Date(year, monthIndex, 1)).getTime();
  return {
    inRange: time >= bounds.start.getTime() && time <= bounds.end.getTime(),
    edge: time === bounds.start.getTime() || time === bounds.end.getTime()
  };
}